/**
 * 热门游戏模块
 * @description 封装 Games 组件，提供热门游戏数据获取能力
 */
import React, { useRef, useImperativeHandle } from 'react';
import Games, { IGamesInstance } from '../Games';
import { fetchTopGamesTable, fetchTopGamesChart } from '../../services';
import { ChartType } from '@intelligence/v3/enums/chart';

import type { ICasualCompetitorsDataSourceProps, ICasualCompetitorsParams } from '../../types';

export interface ITopGamesInstance {
  update: (params: ICasualCompetitorsParams) => void;
}

interface ITopGamesProps extends ICasualCompetitorsDataSourceProps {
  keyGamesTableTipsI18n?: IRecord<IRecord<string>>;
  params: ICasualCompetitorsParams | null;
  genreOptionsMap?: IRecord<any[]>;
  metricTab?: string;
  onMetricTabChange?: (value: string) => void;
  chartType?: ChartType;
  onSortStateChange?: (sortState: IRatioMetricSortState<IRecord>) => void;
  onSortedGameIdsChange?: (gameIds: string[]) => void;
}

const TopGames: React.ForwardRefRenderFunction<ITopGamesInstance, ITopGamesProps> = (props, ref) => {
  const {
    keyGamesTableTipsI18n,
    params,
    genreOptionsMap,
    dataSource,
    metricTab,
    onMetricTabChange,
    chartType,
    onSortStateChange,
    onSortedGameIdsChange,
  } = props;
  const gamesRef = useRef<IGamesInstance>(null);

  useImperativeHandle(ref, () => ({
    update: (params: ICasualCompetitorsParams) => {
      gamesRef.current?.update(params);
    },
  }));

  return (
    <Games
      ref={gamesRef}
      keyGamesTableTipsI18n={keyGamesTableTipsI18n}
      params={params}
      dataSource={dataSource}
      genreOptionsMap={genreOptionsMap}
      fetchTable={fetchTopGamesTable}
      fetchChart={fetchTopGamesChart}
      metricTab={metricTab}
      onMetricTabChange={onMetricTabChange}
      chartType={chartType}
      onSortStateChange={onSortStateChange}
      onSortedGameIdsChange={onSortedGameIdsChange}
    />
  );
};

export default React.forwardRef(TopGames);
